import type { Routes } from '@atlassian/react-resource-router/src/common/types';
// eslint-disable-next-line jira/import-whitelist
import { fg } from '@atlassian/jira-feature-gating';
import { getSpaRoutes } from './getSpaRoutes.tsx';
import { getCodegenSpaRoutes } from './getCodegenSpaRoutes.tsx';

// Yes, this is a kind of re-export, yes they're bad - however we need a separate asset to act as a "jump asset"
// to allow us to apply the `unstable_forceSkipWrappedAssets` optimisation to the route map. If it was the entry
// point of the bundle this wouldn't work, we still need a wrapped entry point.
const getSpaRoutesAsync = (): Routes => {
	return fg('rollout-codegen-spa-route-map') ? getCodegenSpaRoutes() : getSpaRoutes();
};

export default getSpaRoutesAsync;
